import { useState } from "react";
import { useDispatch } from "react-redux";
import { setCarritoPromos } from "../Redux/actions/CarritoPromoAction";
import * as constant from '../global/const';

export const useCounterRedemption = (value = 0, minValue = 0, integrationType = 0) => {

    const [counter, setCounter] = useState(value);
    let _carritoPromos = JSON.parse(localStorage.getItem(constant.CARRITOPROMO)) || {};

    const dispatchPromo = useDispatch();

    const AgregarCarritoPromos = carritoPromos => dispatchPromo(setCarritoPromos(carritoPromos));

    const handleSubmitAdd = (num = 1, limit, setLimit) => {
        if (limit > 0) {
            setCounter(value => value + num);
            setLimit(limit - 1);
        }
    }

    const handleSubmitSubtract = (num = 1, limit, setLimit) => {
        
        if (!integrationType) {
            if (counter - num >= 0) {
                setCounter(value => value - num);
                setLimit(limit + 1);
            }
        } else {
            if (counter - num >= minValue) {
                setCounter(value => value - num);
                setLimit(limit + 1);
            }
        }
    }

    const handleUpdateRedemption = (codigoSku, redencion) => {
        if (_carritoPromos["-" + codigoSku]) {
            _carritoPromos["-" + codigoSku]['seleccionados'] = redencion;
        }
        AgregarCarritoPromos(_carritoPromos);
    }

    return [counter, handleSubmitAdd, handleSubmitSubtract, handleUpdateRedemption];
}
